import "./styles.sass";
import useTranslate from "../../../hooks/useTranslate";

export const LoyaltyListRewardsPlug = () => {
  const t = useTranslate();
  return (
    <div className="LoyaltyListRewardsPlug">
      <div className="LoyaltyListRewardsPlug__content">
        <div className="LoyaltyListRewardsPlug__title">
          {t("loyalty.redesign.1.placeholder-card.title")}
        </div>
        <div className="LoyaltyListRewardsPlug__description">
          {t("loyalty.redesign.1.placeholder-card.description")}
        </div>
      </div>
    </div>
  );
};
